import { useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";

const COLORS = { Superadmin: "#d946ef", "Pengurus Cawangan": "#0ea5e9", Penyelia: "#f59e0b", Guru: "#10b981", "Ibu Bapa": "#f43f5e", Sistem: "#94a3b8" };
const METRICS = [
  { key: "soalan", label: "Soalan", fmt: (v) => v.toLocaleString() },
  { key: "token", label: "Token", fmt: (v) => v.toLocaleString() },
  { key: "kos", label: "Kos (USD)", fmt: (v) => `$${Number(v).toFixed(4)}` },
];
const color = (r) => COLORS[r] || "#64748b";

/** Graf harian soalan / token / kos Mimi bagi setiap peranan (bertindan). */
export default function AIUsageRoleChart({ harian = [], ringkasan = [], peranan = [] }) {
  const [metric, setMetric] = useState("soalan");
  const m = METRICS.find((x) => x.key === metric);
  const data = harian.map((d) => ({ t: d.tarikh.slice(5), ...Object.fromEntries(peranan.map((r) => [r, d.peranan[r]?.[metric] || 0])) }));

  if (!harian.length) return null;
  return (
    <div className="rounded-xl border border-slate-100 p-2" data-testid="ai-usage-role-chart">
      <div className="flex items-center gap-1.5 mb-1.5">
        <div className="text-[10px] uppercase tracking-wide font-bold text-slate-400 flex-1">Harian ikut peranan</div>
        {METRICS.map((x) => (
          <button key={x.key} onClick={() => setMetric(x.key)} data-testid={`ai-usage-role-metric-${x.key}`}
            className={`px-2 py-0.5 rounded-full text-[10.5px] font-bold border transition-colors ${metric === x.key ? "bg-slate-800 text-white border-slate-800" : "bg-white text-slate-500 border-slate-200 hover:border-slate-400"}`}>{x.label}</button>
        ))}
      </div>
      <div className="h-40">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis dataKey="t" tick={{ fontSize: 9 }} />
            <YAxis tick={{ fontSize: 9 }} width={metric === "token" ? 44 : 34} tickFormatter={(v) => (metric === "token" && v >= 1000 ? `${Math.round(v / 1000)}k` : v)} />
            <Tooltip contentStyle={{ fontSize: 11, borderRadius: 10 }} formatter={(v, n) => [m.fmt(v), n]} />
            <Legend wrapperStyle={{ fontSize: 10 }} iconSize={8} />
            {peranan.map((r) => <Bar key={r} dataKey={r} stackId="a" fill={color(r)} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <table className="w-full text-[11px] mt-1.5" data-testid="ai-usage-role-table">
        <thead><tr className="text-slate-400 text-left"><th className="font-bold">Peranan</th><th className="font-bold text-right">Soalan</th><th className="font-bold text-right">Token</th><th className="font-bold text-right">Kos</th></tr></thead>
        <tbody>
          {ringkasan.map((r) => (
            <tr key={r.peranan} className="text-slate-600 border-t border-slate-50" data-testid={`ai-usage-role-row-${r.peranan.replace(/\s+/g, "-").toLowerCase()}`}>
              <td className="py-0.5"><span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ background: color(r.peranan) }} />{r.peranan}</td>
              <td className="text-right">{r.soalan.toLocaleString()}</td>
              <td className="text-right">{r.token.toLocaleString()}</td>
              <td className="text-right font-bold">${r.kos.toFixed(4)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-[10px] text-slate-400 mt-1">Token & kos rekod lama dianggar dari soalan terakhir pengguna; "Sistem" = taklimat & tugas automatik.</div>
    </div>
  );
}
